import React, { useEffect, useRef, useState } from "react";
import UserWrapper from "./uploadFinancialReport.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import UploadFinancialReportForm from "../../components/uploadFinancialReport/UploadFinancialReportForm";
import CategoryServices from "api/CategoryServices";
import EncryptDecrypt from "api/EncryptDecrypt";
import Toaster from "components/common/Toaster";
import UploadProviderSpecificReportForm from "components/uploadProviderSpecificReport/UploadProviderSpecificReportForm";
import { hasAccess } from "util/sidebar";
import { MODULE_NAMES, PERMISSION_TYPE } from "helper/constant";
// import UploadProviderSpecificReportForm from "components/uploadProviderSpecificReport/UploadProviderSpecificReportForm";

const UploadFinancialReport = props => {
  const [isServiceLoading, setIsServiceLoading] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const toaster = useRef();

  useEffect(() => {
    setIsServiceLoading(true);
    CategoryServices.serviceDropdown()
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          setServiceList([...data.data]);
        } else {
          if (toaster.current)
            toaster.current.error("Could not fetch services!");
        }
        setIsServiceLoading(false);
      })
      .catch(err => {
        if (err?.response?.status === 403) {
          if (toaster.current) {
            toaster.current.error("You cannot access this user info!");
            setTimeout(() => {
              props.history.push("/client");
            }, 3000);
          }
        } else {
          if (toaster.current)
            toaster.current.error("Could not fetch services!");
        }
        setIsServiceLoading(false);
      });
  }, []);

  const submitFinanceFormHandler = () => {
    setTimeout(() => {
      props.history.push("/financial-report");
    }, 2000);
  };

  // Check if user has access to upload provider-specific reports
  const hasProviderReportAccess = hasAccess(
    MODULE_NAMES.PROVIDER_SPECIFIC_FINANCIAL,
    PERMISSION_TYPE.ADD,
    props.permissions
  );

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.upload_financial_report"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.upload_financial_report"
            }
          ]}
        />
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Upload Financial Report
            </div>
          </div>
          <div className="roe-card-body">
            <UploadFinancialReportForm
              onSubmit={submitFinanceFormHandler}
              serviceList={serviceList}
              isServiceLoading={isServiceLoading}
              action={"add"}
              {...props}
            />
          </div>
        </div>
      </div>

      {/* Only render provider-specific report section if user has permission */}
      {hasProviderReportAccess && (
        <div className="plr-15">
          <div className="roe-card-style mtb-15">
            <div className="roe-card-header module-header">
              <div className="flex-1 fs-16 demi-bold-text">
                <span className="hash"># </span> Upload Provider Specific XLS
                Report
              </div>
            </div>
            <div className="roe-card-body">
              <UploadProviderSpecificReportForm
                onSubmit={submitFinanceFormHandler}
                serviceList={serviceList}
                isServiceLoading={isServiceLoading}
                action={"add"}
                {...props}
              />
            </div>
          </div>
        </div>
      )}
      <Toaster ref={toaster} />
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(UploadFinancialReport);
